// import { NewStoryComponent } from './new/new.component';
// import { UploadWizardStoryComponent } from './wizard/wizard.component';
// import { ShowStoryComponent } from './show/show.component';
// import { StoriesListComponent } from './list/list.component';
// import { PrintStoryComponent } from './print/print.component';
// import { OrdersComponent } from './orders/orders.component';
// import { UploadProgressComponent } from './uploadProgress/uploadProgress.component';
import { CanActivateApp } from '../services/canActivateApp.service';
import { CanDeactivateShowStory } from 'app/services/can-deactivate-show-story.service';
import { CanDeactivateUploadWizardStory } from 'app/services/can-deactivate-upload-design-style.service';
import { CanDeactivateNewStory } from 'app/services/can-deactivate-new-story.service';
import { CanDeactivatePrintFlow } from 'app/+stories/print/can-deactivate-print-flow.service';
// import { DesigningComponent } from './designing/designing.component';
import { ContainerComponent } from './contrib/container/container.component';
import { UploadComponent } from './contribWizard/upload/upload.component';
import { ContribComponent } from './contrib/contrib.component';
import { ContribWizardComponent } from './contribWizard/contribWizard.component';
import { CanActivateContrib } from 'app/services/canActivateContrib.service';
import { ContribLoginComponent } from './contrib/contribLogin/contribLogin.component';
import { ShowInvitationStoryComponent } from './show/show.component';

export const routes = [
  {
    path: 'projects',
    children: [
      {
        path: ':uuid',
        data: {
          hideDefaultHeader: true,
        },
        children: [
          {
            path: '',
            component: ShowInvitationStoryComponent,
          },
          {
            path: 'contribute',
            data: {
              hideDefaultHeader: false,
            },
            children: [
              {
                path: '',
                component: ContainerComponent,
                children: [
                  {
                    path: '',
                    component: ContribComponent,
                  },
                  {
                    path: 'login',
                    component: ContribLoginComponent,
                  }
                ]
              },
              { path: 'wizard', component: ContribWizardComponent },
            ]
          }
        ]
      },

    ]
  }
];

